<div class="container">
<!--  <h2>{{ status$ | async }}</h2>-->
  <div class="chat-bubble">
    <div class="typing">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>
</div>
